// extracted by mini-css-extract-plugin
export default {"container":"fG-z","disabled":"gG-z","bgBlack":"hG-z","content":"iG-z","countdown":"jG-z","topCaption":"kG-z","topHeading":"lG-z","heading":"mG-z","copy":"nG-z"};